import React from 'react';
import { displayName } from '../../../../App';
import MainGuidanceLayout from '../../../components/Layout/Main';
import Content from '../../../components/Pages/Statements/Checking';

function CheckingStatements() {
  document.title = `${displayName}: Checking Statements`;

  return (
    <MainGuidanceLayout>
      <Content />
    </MainGuidanceLayout>
  );
}

export default CheckingStatements;
